import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Education = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M23.367 3.906a.923.923 0 0 0-1.026 0L2.124 17.622c-.025.012-.037.037-.061.061a.58.58 0 0 0-.123.122c-.012.025-.048.037-.06.061v.013c-.013.024-.025.06-.037.085-.025.05-.05.098-.061.16-.013.024-.025.06-.037.085v.098c0 .024-.012.049-.012.085v10.012L.009 39.2a.922.922 0 0 0 .208.733.894.894 0 0 0 .697.318h3.471a.936.936 0 0 0 .697-.318.948.948 0 0 0 .208-.733L3.566 28.404v-8.288l7.028 4.768v6.393c0 1.381.685 2.665 1.822 3.435l4.632 3.142a10.355 10.355 0 0 0 5.818 1.797c2.03 0 4.046-.599 5.819-1.797l4.632-3.142a4.147 4.147 0 0 0 1.821-3.435v-6.393l8.459-5.734a.902.902 0 0 0 .403-.758.903.903 0 0 0-.403-.758L23.367 3.906Zm-21.39 34.51.66-4.144.66 4.144h-1.32Zm30.301-5.232-4.632 3.142c-2.91 1.98-6.662 1.968-9.571 0l-4.645-3.142a2.312 2.312 0 0 1-1.014-1.92v-5.146l9.925 6.736c.159.11.33.159.513.159a.877.877 0 0 0 .514-.159l9.925-6.736v5.147c0 .77-.38 1.491-1.015 1.92Zm-9.424-2.188L5.62 19.296h17.234a.923.923 0 0 0 .917-.916.923.923 0 0 0-.917-.917H5.62L22.854 5.776l18.58 12.604-18.58 12.616Z"
  }));
});
Education.displayName = 'Education';
Education.defaultProps = {
  'aria-label': 'Education'
};
export default Education;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Subject/Education.js
// module id = 3634
// module chunks = 11